import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { CategoryClass } from '../ecom-items/ecom-item-category/ecom-item-category.model';
export class EcomOlarDataService {
    constructor() { }

    public subject = new Subject<any>();

    public menuDetails: any = [];
    private menuSource = new BehaviorSubject(this.menuDetails);
    currentMenu = this.menuSource.asObservable();
    updateMenuDetails(menu: []) {
        this.menuSource.next(menu);
    }

    public menuDetailsnew: any = [];
    private menuSourcenew = new BehaviorSubject(this.menuDetailsnew);
    currentMenunew = this.menuSourcenew.asObservable();
    updateMenunewDetails(menu: []) {
        this.menuSourcenew.next(menu);
    }

    // to handle the filters master data
    public filtersArray: any = [];
    private filtersArraySource = new BehaviorSubject(this.filtersArray);
    currentfiltersArray = this.filtersArraySource.asObservable();
    updatefiltersArraySource(data: []) {
        this.filtersArraySource.next(data);
    }

    // to handle the filters selected data
    public filtersArraySelected: any = [];
    private filtersArraySourceSelected = new BehaviorSubject(this.filtersArraySelected);
    currentfiltersArraySelected = this.filtersArraySourceSelected.asObservable();
    updatefiltersArraySelectedSource(data: []) {
        this.filtersArraySourceSelected.next(data);
    }

    private categorySource = new BehaviorSubject<CategoryClass[]>([]);
    currentCategories = this.categorySource.asObservable();
    updateCategoryList(categories: CategoryClass[]) {
        this.categorySource.next(categories);
    }

    private upSellSource = new BehaviorSubject<any[]>([]);
    currentUpSell = this.upSellSource.asObservable();
    updateUpSellList(items: any[]) {
        this.upSellSource.next(items);
    }
}